module.exports = __webpack_public_path__ + "static/media/con_spa_iso.740c2847.png";